import type { SessionFeedbackFeaturedAttributes } from '@/server/models'

import { SQL, type SQLFragment } from '@/client/query'

import {
  type AssociationDefinitions,
  type GroupBy,
  type IncludeAssociations,
  includeAssociationsToSql,
  makeQueryModelV2,
  type QueryOrder,
  queryGroupByToSQL,
  queryLimitToSQL,
  queryOrderToSQL,
} from './common'
import SessionFeedbackQ from './SessionFeedbackQ'

const SessionFeedbackFeaturedQ = {
  ...makeQueryModelV2<SessionFeedbackFeaturedAttributes>('session_feedback_featured')([
    'id',
    'session_feedback_id',
    'user_id',
    'created_at',
    'updated_at',
    'deleted_at',
    'on_stories_page',
  ]),

  associations: (): AssociationDefinitions => ({
    SessionFeedback: {
      query: SessionFeedbackQ,
      foreignKey: SessionFeedbackQ.id,
      sourceKey: SessionFeedbackFeaturedQ.session_feedback_id,
    },
  }),

  where: (
    {
      sessionFeedbackId,
      paranoid = true,
      userId,
      onStoriesPage,
      include = [],
      groupBy = null,
      order = null,
      limit = null,
    }: {
      sessionFeedbackId?: number | null | SQLFragment<number>
      paranoid?: boolean
      userId?: number | null | SQLFragment<number>
      onStoriesPage?: boolean
      include?: IncludeAssociations
      groupBy?: GroupBy | null
      order?: QueryOrder | null
      limit?: number | null
    },
    customWhere: SQLFragment<unknown> | null = null
  ): SQLFragment<SessionFeedbackFeaturedAttributes> => SQL`
        FROM ${SessionFeedbackFeaturedQ}
        ${includeAssociationsToSql(SessionFeedbackFeaturedQ, include)}
        WHERE
            ${
              sessionFeedbackId != null
                ? SQL`${SessionFeedbackFeaturedQ.session_feedback_id} = ${sessionFeedbackId} AND`
                : SQL``
            }
            ${userId != null ? SQL`${SessionFeedbackFeaturedQ.user_id} = ${userId} AND` : SQL``}
            ${onStoriesPage === true ? SQL`${SessionFeedbackFeaturedQ.on_stories_page} AND` : SQL``}
            ${paranoid ? SQL`${SessionFeedbackFeaturedQ.deleted_at} IS NULL AND` : SQL``}
            ${customWhere != null ? customWhere : SQL`TRUE`}
        ${queryGroupByToSQL(groupBy)}
        ${queryOrderToSQL(order)}
        ${queryLimitToSQL(limit)}
    `,
}

export default SessionFeedbackFeaturedQ
